export enum GlobalActionTypes {
  CLEAR_STATE = '@global/CLEAR_STATE',
  NONE = 'NONE',
}
